<template>
  <div class="pickedStaff">
    <div class="header">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">
        已选择内部参会人：{{ pickedList.length }}
      </span>
      <div class="confirm" @click="onConfirm">确认</div>
    </div>
    <van-checkbox-group v-model="picked">
      <van-cell-group>
        <van-cell
            v-for="(item, index) in pickedList"
            :key="item.id"
            clickable
            @click="toggle(index)"
        >
          <template #title>
            <div class="title">
              <svg-icon icon-class="staff_avatar" style="font-size: 0.35rem" />
              <div class="value">
                <span class="name">{{ item.name }}</span>
                <span class="department">{{ item.department }}</span>
              </div>
            </div>
          </template>
          <template #right-icon>
            <van-checkbox ref="checkboxes" :name="item.id" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
  </div>
</template>

<script>
import { Checkbox, CheckboxGroup } from 'vant';

export default {
  name: 'CheckboxStaffPicked',
  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox
  },
  data() {
    return {
      pickedList: [],
      treeList: [],
      picked: []
    };
  },
  created() {
    const pickedList = JSON.parse(this.$route.query.pickedList);
    this.treeList = JSON.parse(this.$route.query.treeList);
    const staffList = JSON.parse(this.$route.query.staffList);
    this.picked = pickedList;
    const list = [];
    function deepData(arr) {
      arr.forEach(item => {
        if (pickedList.includes(item.id)) {
          list.push(item);
        }
        if (item.nodes) {
          deepData(item.nodes);
        }
      });
    }
    deepData([staffList]);
    this.pickedList = list;
  },
  methods: {
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    goBack() {
      this.$router.go(-1);
    },
    onConfirm() {
      // this.$store.dispatch('setStaffIds', { list: this.picked });
      const checkboxStaffPicked = JSON.stringify(this.picked)
      this.$router.push({
        name: 'checkboxStaff',
        query: {
          title: this.$route.query.title,
          from: this.$route.query.from,
          id: this.$route.query.id,
          checkboxStaffPicked
        }
      });
      // this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.pickedStaff {
  .header {
    height: 0.44rem;
    font-size: 0.17rem;
    font-weight: 400;
    line-height: 0.24rem;
    color: #333333;
    background: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.135rem;
    .confirm {
      color: #3B86FF;
    }
  }
  .title {
    display: flex;
    align-items: center;
    .value {
      display: flex;
      flex-direction: column;
      margin-left: 0.05rem;
      .name {
        font-size: 0.17rem;
        font-weight: 400;
        line-height: 0.24rem;
        color: #001833;
      }
      .department {
        font-size: 0.14rem;
        font-weight: 400;
        line-height: 0.2rem;
        color: #333333;
      }

    }
  }
}
</style>
